// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMeta from 'vue-meta'
import url from '@/assets/json/url'
import namespace from '@/assets/js/nknNamespace'
import VueLazyload from 'vue-lazyload'
import i18n from '@/i18n'
import store from '@/store'
import axios from 'axios'
import fontawesome from '@fortawesome/fontawesome'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import regular from '@fortawesome/fontawesome-free-regular'
import brands from '@fortawesome/fontawesome-free-brands'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
// import '@/assets/css/global.css'
import '@/assets/scss/common.scss'
import NKNTasks from './tasks/nknTask';
import NknChat from 'vue-nkn-chat'
import hljs from 'highlight.js'
import 'highlight.js/styles/monokai.css'
let Highlight = {}
Highlight.install = function (Vue, options) {
  Vue.directive('highlight', function (el) {
    let blocks = el.querySelectorAll('pre code');
    blocks.forEach((block) => {
      hljs.highlightBlock(block)
    })
  })
}
Vue.use(Highlight)
Vue.use(NknChat)
fontawesome.library.add(solid)
fontawesome.library.add(regular)
fontawesome.library.add(brands)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

Vue.use(NKNTasks)
Vue.use(VueMeta, {
  attribute: undefined,
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false
Vue.prototype.$url = url
Vue.prototype.$namespace = namespace
Vue.prototype.$http = axios
Vue.use(VueLazyload, {
  preload: 1.3,
  error: '',
  loading: ''
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {App},
  template: '<App/>',
  mounted() {
    //this.$NKNTasks.geoList.start()
    //this.$NKNTasks.geoSummary.start()
  }
})



// WEBPACK FOOTER //
// ./src/main.js